import { render, staticRenderFns } from "./PointSlideLivePopup.vue?vue&type=template&id=424a1b04&scoped=true"
import script from "./PointSlideLivePopup.vue?vue&type=script&lang=js"
export * from "./PointSlideLivePopup.vue?vue&type=script&lang=js"
import style0 from "./PointSlideLivePopup.vue?vue&type=style&index=0&id=424a1b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.11_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424a1b04",
  null
  
)

export default component.exports